import { render, staticRenderFns } from "./ImportarProcessosCompra.vue?vue&type=template&id=3843ffb1&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarProcessosCompra.vue?vue&type=style&index=0&id=3843ffb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843ffb1",
  null
  
)

export default component.exports